<template lang="pug">
.v-field-toggler.field-toggler(:class="computedClass")
	.field-label(v-if="field.label && field.mode !== 'no-label'")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	.field-toggler__box
		template(v-for="(option, index) in field.options" :key="index")
			button.field-toggler__button(
				@click="localValue = option.value; handleInput();"
				:class="{'field-toggler__button--active' : localValue === option.value} "
				type="button")
				| {{option.text}}

</template>

<script>
	export default  {
		emits: [
			'update:model-value',
		],
		props: {
			field: {
				type:Object,
				default: null
			},
			modelValue: {
				type: [Object, String, Number, Boolean, Symbol, Date],
				default: null
			},
		},

		data() {
			return {
				localValue: null
			}
		},
		methods: {
			updateLocalValue() {
				this.localValue = this.modelValue;
			},
			handleInput() {
				this.$emit('update:model-value', this.localValue);
				this.updateLocalValue()
			}
		},
		computed: {
			computedClass() {
				return [
					'field-toggle--' + (this.field?.size || 'l'),
				];
			}
		},
		watch: {
			modelValue: {
				immediate: true,
				handler() {
					this.updateLocalValue();
				}
			}
		}
	}
</script>